import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { FeatureRestrictedModalContent } from 'entities/UsersPermissions/ui/FeatureRestrictedModal/ui/FeatureRestrictedModalContent'

export class FeatureRestrictedModalStore {
  constructor(desc: string, onCloseCallback?: () => void) {
    makeAutoObservable(this)
    this.openModal(desc, onCloseCallback)
  }

  _idModal = ''
  onCloseCallback: (() => void) | null = null

  closeModal = () => {
    modalStore.removeModal(this._idModal)
  }

  openModal = (desc: string, onCloseCallback?: () => void) => {
    this._idModal = nanoid()
    this.onCloseCallback = onCloseCallback || null

    modalStore.addModal({
      id: this._idModal,
      showCloseIcon: false,
      showHeader: false,
      ModalContentProps: {
        desc,
      },
      ModalContent: FeatureRestrictedModalContent,
      closeText: 'Close',
      onClose: () => {
        this.closeModal()
        this.onCloseCallback?.()
      },
    })
  }
}
